var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "200px",
    height: "175px",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 200 175",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1684395331792"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0D80D8",
    d: "M29 109l15 -1c0,-11 -7,-21 4,-44 3,-7 7,-14 12,-20 10,-11 30,-20 45,-20 17,0 23,2 37,10 5,2 11,7 14,11 12,14 18,25 18,48 0,14 -6,30 -16,40 -4,6 -6,8 -12,12 -17,12 -38,15 -57,9 -9,-3 -14,-7 -17,-7 -4,0 -12,5 -16,6 3,4 15,10 20,13 4,1 8,3 13,4 6,1 12,2 18,2l3 0c16,0 30,-5 44,-14 12,-8 21,-19 27,-31 13,-27 11,-59 -6,-84 -14,-19 -39,-33 -62,-33 -20,0 -27,0 -45,10 -5,2 -9,6 -13,9 -4,4 -7,6 -11,11 -13,17 -15,29 -18,49 0,7 3,17 3,20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1AF0C",
    d: "M8 167c3,0 7,-2 10,-3l137 -53c3,-1 7,-3 9,-5 -5,0 -9,1 -13,1 -4,0 -9,-1 -13,0l-104 5c-7,1 -5,2 -11,16l-15 39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1AF0C",
    d: "M96 106l3 0c8,0 13,0 20,0l0 -71 -23 0 0 71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1AF0C",
    d: "M125 105l16 -1c3,0 8,1 8,-2l0 -58 -24 0 0 61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0922D",
    d: "M67 108c8,0 14,-1 23,-1l0 -46c0,-1 0,-2 -2,-2l-21 0 0 49z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.09eaf25420b36956e933d52a3dfd7c5d.svg";
export { ForwardRef as ReactComponent };